import messages from './pin-modal-translations';

export default {
    name: 'instamapsPinModal',
    i18n: {
        messages,
    },
    data: function () {
        return {
            itemExpanded: null,
        };
    },
    props: {
        show: { type: Boolean },
        title: { type: String },
        htmlContent: { type: String },
        pins: { type: Array },
    },
    methods: {
        dismiss: function () {
            this.$emit('closePinModal');
        },
        isFirstItem: function (item) {
            return (this.pins.indexOf(item) === 0) ? true : false;
        },
        toggleItem: function (pin) {
            (this.itemExpanded === pin) ? this.itemExpanded = undefined: this.itemExpanded = pin;
        },
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/pin-modal/pin-modal.js